import React from 'react';
import Modal from './Modal';

// Chiusura della lobby da parte del banditore. E' l'unica azione irreversibile
// dell'applicazione — non c'e' un cestino, lo snapshot su disco viene
// cancellato — quindi passa da una conferma esplicita e non da un solo click
// in un menu.

export default function CloseLobbyModal({ show, lobbyName, error, pending, onConfirm, onClose }) {
    return (
        <Modal
            open={show}
            title="Chiudi l'asta"
            onClose={onClose}
            footer={
                <>
                    <button type="button" className="btn btn--ghost" onClick={onClose}>
                        Annulla
                    </button>
                    <button
                        type="button"
                        className="btn btn--stop"
                        onClick={onConfirm}
                        disabled={pending}
                    >
                        {pending ? 'Chiusura…' : "Chiudi l'asta"}
                    </button>
                </>
            }
        >
            <p>
                Vuoi chiudere <strong>{lobbyName}</strong>?
            </p>
            <p className="notice notice--stop">
                Tutti i partecipanti vengono disconnessi e l&apos;asta viene cancellata dal
                server: rose, offerte e registro non sono piu recuperabili.
            </p>
            {error && <p className="notice notice--warn">{error}</p>}
        </Modal>
    );
}
